$(".overview ul li").click(function(){ // don't need each (click does this internally)
 $(this).children().addClass('active') //add cell-selected class to a
 .parent() //go back to li
 .siblings() //look at siblings
 .find('.active') //find cell-selected elements
 .removeClass('active'); //remove the class
});

$(document).on('click', '.overview ul li a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 190
    }, 500);
});

$('.related-product-area').insertBefore("#reviews");

$('.shocialsharebtn').click(function() {
  $('.modaldiv').parents().find('.template-product').addClass('fixedbody');
  $('.modaldiv').css('display', 'flex');
});
$('.modalsclose').click(function() {
 $('.modaldiv').parents().find('.template-product').removeClass('fixedbody');
  $('.modaldiv').css('display', 'none');
});

if($(window).width() < 481)
{
   $("#mediaaftercontent-heading").insertBefore(".prod-thumbs");
} else {
   // change functionality for larger screens
}





function photoswip(){
  $('.pswp__container .pswp__item').click(function(){
    $('.pswp__container .pswp__item').removeClass('active')
    $(this).toggleClass('active')
})
}

$('.grid__item .product-buttons').click(function(){
  photoswip()
})

